import { useAppSelector } from "screens/Root/hooks/useAppSelector";
import React, { useCallback, useRef, useState } from "react";
import TopMenuLevelZero from "./TopMenulLevelZero";
import { Box, withStyles } from "@material-ui/core";
import { getElementWidth } from "meta/utils/getElementWidth";
import useResizeObserver from "use-resize-observer";
import { MoreMenu } from "./components/MoreMenu";
import { useDispatch } from "react-redux";
import { closeMenu } from "./slice";
const Container = withStyles({
    root: {
        alignSelf: "stretch",
        display: "flex",
        alignItems: "stretch",
        overflow: "hidden",
        flexGrow: 1,
    },
})(Box);
const empty = [];
const ResponsiveTopMenu = () => {
    const topMenus = useAppSelector((state) => state.root.appSettings.StaticData?.TopMenus || empty);
    const widthCache = useRef({});
    const getByType = (type) => topMenus.filter((x) => x.Type === type);
    const topMenusText = getByType("TopmenuText");
    const topMenusPinned = getByType("TopmenuPinned");
    const containerRef = useRef(null);
    const moreMenuRef = useRef(null);
    const visibleMenuRef = useRef(null);
    const pinnedMenuRef = useRef(null);
    const [hiddenFromIndex, setHiddenFromIndex] = useState(Infinity);
    const dispatch = useDispatch();
    const handleResize = useCallback(() => {
        dispatch(closeMenu(""));
        const calculateAvailableSpace = () => {
            const containerWidth = getElementWidth(containerRef.current, Infinity);
            const moreMenuWidth = getElementWidth(moreMenuRef.current, 70);
            const pinnedMenuWidth = getElementWidth(pinnedMenuRef.current);
            return containerWidth - pinnedMenuWidth - moreMenuWidth;
        };
        const availableSpace = calculateAvailableSpace();
        const tryRemoveMenus = () => {
            let didRemove = false;
            const textVisibleChildren = Array.from(visibleMenuRef.current?.children || []);
            textVisibleChildren.reduce((previous, topMenuElement, index) => {
                const width = getElementWidth(topMenuElement);
                widthCache.current[topMenusText[index].ID] = width;
                if (didRemove) {
                    return previous;
                }
                if (availableSpace - previous < width) {
                    setHiddenFromIndex(index);
                    didRemove = true;
                }
                return previous + width;
            }, 0);
            return didRemove;
        };
        const tryAddMenus = () => {
            let lastFittingIndex = -1;
            topMenusText.reduce((previous, element, index) => {
                const cachedWidth = widthCache.current[element.ID] || 0;
                if (availableSpace - previous > cachedWidth) {
                    lastFittingIndex = index + 1;
                }
                return previous + cachedWidth;
            }, 0);
            if (lastFittingIndex > 0) {
                setHiddenFromIndex(lastFittingIndex);
            }
        };
        const didRemove = tryRemoveMenus();
        if (!didRemove) {
            tryAddMenus();
        }
    }, [topMenus, setHiddenFromIndex]);
    useResizeObserver({
        onResize: () => window.requestAnimationFrame(handleResize),
        ref: containerRef.current,
    });
    return (<Container 
    // @ts-ignore
    ref={containerRef}>
      <div style={{ display: "flex" }} ref={visibleMenuRef}>
        {topMenusText.slice(0, hiddenFromIndex).map((menu) => (<TopMenuLevelZero key={menu.ID} menu={menu}/>))}
      </div>
      {hiddenFromIndex < topMenusText.length && (<MoreMenu menus={topMenusText.slice(hiddenFromIndex)}/>)}
      <div style={{ flexGrow: 1 }}/>
      <div style={{ display: "flex" }} ref={pinnedMenuRef}>
        {topMenusPinned.map((menu) => (<TopMenuLevelZero key={menu.ID} menu={menu}/>))}
      </div>
    </Container>);
};
export default ResponsiveTopMenu;
